import React, {} from 'react';
import { Text } from 'common-components/typography';
import { Empty } from 'antd';
import _ from 'lodash';

export const BookingsTableEmptyState = () => (
  <div className='mt-x2-large align-center flex-column flex-1 bg-white'>
    <div className=''>
      <Empty description={false} image={Empty.PRESENTED_IMAGE_SIMPLE} className='mv-none' />
    </div>
    <Text size='x2-large' color='secondary' weight='bold'>
      No matching bookings found.
    </Text>{' '}
    <br /> <br />
    <Text color='secondary'>All bookings under this filter will appear here.</Text>
    <Text color='secondary'>Try adjusting your filter, or clicking on another view.</Text>
  </div>
);
